export { default as MarketingTileGroup } from './marketing-tile-group';
